import { render, staticRenderFns } from "./InsurersList.vue?vue&type=template&id=15b9de54"
import script from "./InsurersList.vue?vue&type=script&lang=js"
export * from "./InsurersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports